import {h, Fragment} from "preact"
import { useFacet, useProductFilters, useAppStateSelector, pick } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"
import { useEffect, useRef, useState } from "preact/hooks"
import { sortSizes } from "./utils/sortSizes";
import { translatedText } from "./utils/translatedText";

export default function Facet({ facet, isActive, setActive, handleClick }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const { query, response } = useAppStateSelector(state =>
        pick(state, "query", "response")
      );
    const { filters, removeAll } = useProductFilters()
    const dropdownRef = useRef(null)
    const [maxHeight, setMaxHeight] = useState("0px")

    const docCount = response.products?.total ?? 0;
    const hasActiveFilters = (selectedFiltersCount ?? filters.length ?? 0) > 0;
    const addFilterLabel = hasActiveFilters
    ? `${translatedText("apply")} ${docCount > 0 ? `[${docCount}]` : ""}`
    : `${translatedText("seeAll")} ${docCount > 0 ? `[${docCount}]` : ""}`;
    const clearLabel = hasActiveFilters ? `${translatedText("clearAll")}` : ''


    useEffect(() => {
        if (dropdownRef.current) {
            setMaxHeight(isActive ? `${dropdownRef.current.scrollHeight}px` : "0px") 
        }
    }, [isActive])
    
    return (
        <li 
            class={`ns-sidebar-dropdown ${isActive ? "ns-active" : ""}`} 
            aria-expanded={!!isActive} 
            onClick={() => {
                setActive(!isActive)
            }}
        >
            <span
                class="ns-anchor ns-relative ns-w-100 ns-border-box px-8 py-12 ns-p flex justify-between items-center gap-4 lg:px-0"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${isActive ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class={`capitalize flex items-center text-13-120--0.5-700 ${isActive ? 'opacity-50' : ''} ${facet.name}`}>
                    {facet.name}
                    {selectedFiltersCount > 0 && (
                        <div class="text-black-55">
                            [ 
                            <span class="text-black">
                                {selectedFiltersCount}
                            </span>
                            ]
                        </div>
                    )}
                </span>

                <span class={`transition-all ease-jl duration-600 ${isActive ? 'rotate-180' : 'rotate-0'}`}>
                    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 0.5L6 5.5L11 0.500005" stroke="currentColor" stroke-width="2"></path> 
                    </svg>
                </span>
            </span>

            <div 
                ref={dropdownRef}
                class="ns-sidebar-submenu bg-white inset-x-0 lg:absolute lg:z-10 overflow-hidden transition-all duration-500"
                id={`${facet.id}-sub-menu`}
                style={{ maxHeight }}
            >
                <ul class="grid grid-cols-2 gap-24 px-12 py-12 lg:px-24 lg:grid-cols-24 lg:p-12 lg:pt-24 lg:gap-y-16" role="menu">
                {(facet.name === "Size" ? sortSizes(facet.data) : facet.data)?.map(value => (
                    <li
                    key={value.value}
                    class="ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3 h-fit lg:col-span-4"
                    data-nosto-element="facet-setting"
                    role="menuitem"
                    >
                    <Checkbox
                        value={value.value}
                        selected={value.selected}
                        onChange={e => {
                        e.preventDefault()
                        toggleProductFilter(facet.field, value.value, !value.selected)
                        }}
                    />
                    </li>
                ))}
                </ul>
                <div class="hidden lg:flex gap-24 px-12 pb-12 pt-48 lg:px-24 desktop-action-buttons">
                    <button onClick={toggleActive} class="btn-fill btn-fill-primary-black whitespace-nowrap">
                        <span>{addFilterLabel}</span>
                    </button>
                    {hasActiveFilters && ( 
                    <button
                        onClick={removeAll}
                        class="btn-fill btn-fill-primary-black whitespace-nowrap"
                    >
                        <span>{clearLabel}</span>
                    </button>
                    )}
                </div> 
            </div>
        </li>
    )
}
